import Link from 'next/link'

const ThemeCard = (props) => {
  const { linkHref, color, url, content, image, curator } = props

  let modifier = (color !== 'default') ? ` ThemeCard--${color}` : ''

  return (
    <Link href={ linkHref ? linkHref : `/vision/[slug]`} as={url.replace(process.env.PROJECT_URL, '')}>
      <a className={`ThemeCard${modifier}`}>
        {content &&
        <div className="ThemeCard-main">
          <div className="ThemeCard-content">
            {content.label &&
            <div className="ThemeCard-label">
              <span className="ThemeCard-labelText">{ content.label }</span>
              <svg className="ThemeCard-labelArrow">
                <use xlinkHref="#icon-arrow-right"/>
              </svg>
            </div>
            }
            {content.title &&
            <div className="ThemeCard-title">
              <p>{ content.title }</p>
            </div>
            }
            {curator &&
            <p className="ThemeCard-curatedBy">
              <span className="ThemeCard-author">Curated by {curator.name}</span>
              <span className="ThemeCard-authorRole"> — {curator.role}</span>
            </p>
            }
          </div>
        </div>
        }
        {image &&
        <div className="ThemeCard-aside">
          <div className="ThemeCard-figure">
            <img className="ThemeCard-image" src={image.url} alt={image.alt} />
          </div>
        </div>
        }
      </a>
    </Link>
  )
}

export default ThemeCard
